export const getRebuyData = (callback, id, shopify_product_ids='', limit=10, metafields=false) => {
  fetch(`https://rebuyengine.com/api/v1/custom/id/${id}?shop=${Shopify.shop}&key=${window.rebuyApiKey}${metafields ? '&metafields=yes' : ''}&limit=${limit}&shopify_product_ids=${shopify_product_ids}`)
    .then((blob) => blob.json())
    .then((response) => {
      callback(response.data)
    })
}